<template>
    <div>
        <button class="main-menu-toggler" @click="toggleNav">Menú</button>
        <div class="main-menu hidden" ref="mainMenu">
            <video class="main-menu-video" autoplay muted loop>
                <source :src="require('@/assets/video/seamin-short.mp4')" type="video/mp4">
            </video>

            <div class="angle angle-top"></div>
            <div class="angle angle-bottom"></div>

            <div class="main-menu-menu">
                <ul class="main-menu-menu-ul">
                    <li class="main-menu-menu-ul-li">
                        <router-link to="/">Inicio</router-link>
                    </li>
                    <li class="main-menu-menu-ul-li">
                        <router-link to="/services">Servicios</router-link>
                    </li>
                    <li class="main-menu-menu-ul-li">
                        <router-link to="/#homeProjectsList">Proyectos</router-link>
                    </li>
                    <li class="main-menu-menu-ul-li">
                        <router-link to="/about">Kraken Labs</router-link>
                    </li>
                    <li class="main-menu-menu-ul-li">
                        <a href="https://blog.krakenlabsweb.com">Blog</a>
                    </li>
                    <li class="main-menu-menu-ul-li">
                        <router-link to="/contact">Contacto</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import Vue from 'vue';
    import gsap, { Power1, Power2 } from 'gsap';


    export default Vue.extend({
        name: 'MainMenu',
        methods: {
            toggleNav( action = 'toggle' ) {
                const element = this.$refs.mainMenu as HTMLElement;

                if( action == 'show' ) {
                    this.showNav( element );
                    return;
                }

                if( action == 'hide' ) {
                    this.hideNav( element );
                    return;
                }

                const isHidden = +window.getComputedStyle(element).left.slice(0,1) > 0;

                if( isHidden )
                    this.showNav( element );
                else
                    this.hideNav( element );
            },
            hideNav( element: HTMLElement ) {
                const linkelements  = [...element.querySelectorAll('.main-menu-menu-ul-li a')];
                const angleElements = [...element.querySelectorAll('.angle')];
                const toggler       = document.querySelector('.main-menu-toggler') as HTMLElement;
                toggler.classList.remove('closable');

                const tl  = gsap.timeline();

                tl.to( toggler, .6, {transform: 'rotateZ(-90deg)', color: '#fff',  ease: Power1.easeInOut}, 0 )
                angleElements.forEach( elm => tl.to( elm, .6, {width: '0', ease: Power2.easeIn},  '<' ) )
                linkelements.forEach( elm => tl.to( elm, .6, {opacity: '0', ease: Power2.easeOut}, '-=.45' ) )
                tl.to( element, .3, {height: '50vh', top: '25vh', ease: Power2.easeIn}, '<' )
                tl.to( element,  .35, {left: '100vw', ease: Power2.easeOut}, '<' )
            },
            showNav( element: HTMLElement ) {
                const linkelements  = [...element.querySelectorAll('.main-menu-menu-ul-li a')];
                const angleElements = [...element.querySelectorAll('.angle')];
                const toggler       = document.querySelector('.main-menu-toggler') as HTMLElement;
                toggler.classList.add('closable');

                const tl  = gsap.timeline();

                tl.to( toggler, .6, {color: 'transparent',  ease: Power1.easeOut}, 0 )
                tl.to( toggler, .6, {transform: 'rotateZ(-90deg)', ease: Power1.easeIn}, '-=1' )
                tl.to( element, .6, {left: 0, ease: Power1.easeOut}, '<' )
                tl.to( element, {height: '100vh', top: 0,  ease: Power1.easeIn}, '-=.4' )
                angleElements.forEach( elm => tl.to( elm, .6, {width: '35vw', ease: Power1.easeIn},  '<' ) )
                linkelements.forEach( elm => tl.to( elm, .6, {opacity: '1', ease: Power1.easeIn},  '-=.3' ) )
            }
        }
    })
</script>

<style scoped lang="scss">
    .main-menu {
        position: fixed;
        left: 0;
        top: 25vh;
        width: 100vw;
        height: 50vh;
        z-index: 10;
        background-color:#292a2cea;
        border: 1px solid #3B3D45;
        transition: all .25s;

        &.hidden {
            left: 100%;
        }

        &-toggler {
            position: fixed;
            z-index: 10;
            right: 0;
            top: 50%;
            transform: rotateZ(-90deg);
            -webkit-transform: rotateZ(-90deg);
            padding: .6rem;
            min-width: 100px;
            background: transparent;
            border: none;
            mix-blend-mode: difference;
            font-size: .9rem;
            letter-spacing: 1.3px;
            color: #fff;
            cursor: pointer;
            z-index: 11;
            user-select: none;
            outline-color: transparentize($color: #fff, $amount: .7);
            outline: none;

            &::before,
            &::after {
                content: '';
                    display: block;
                width: 10%;
                height: 1px;
                background-color: #fff;
                position: absolute;
                left: 90%;
                top: 50%;
                transition: all .25s ease-out;
            }

            &:hover {
                &::before {
                    width: 60%;
                }
            }

            &.closable {
                &::before {
                    content: '';
                    width: 60%;
                    height: 1px;
                    background-color: #fff;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transition: all .25s ease-out;
                    transform: rotateZ(45deg);
                }

                &::after {
                    content: '';
                    display: block;
                    width: 60%;
                    height: 1px;
                    background-color: #fff;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transition: all .25s ease-out;
                    transform: rotateZ(-45deg);
                }

                &:hover {
                    &::before {
                        transform: rotateZ(135deg);
                    }

                    &::after {
                        transform: rotateZ(-135deg);
                    }
                }
            }
        }

        &-video {
            width: 95%;
            height: 95%;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            border-radius: 12px;
            opacity: .1;
            z-index: -1;
            object-fit: cover;
        }

        & .angle {
            position: absolute;
            width: 0;
            height: 1px;
            background-color: #fff;
            transition: all .25s;
            
            &-top {
                top: 3vmax;
                right: 4vmax;

                &::before {
                    content: '';
                    width: 50%;
                    height: 1px;
                    position: absolute;
                    left: 75%;
                    top: 0;
                    background-color:  #fff;
                    border-radius: 12px;
                    transform: rotateZ(90deg) translateX(50%);
                    -webkit-transform: rotateZ(90deg) translateX(50%);
                }
            }

            &-bottom {
                bottom: 3vmax;
                left: 4vmax;

                &::before {
                    content: '';
                    width: 50%;
                    height: 1px;
                    position: absolute;
                    right: 75%;
                    top: 0;
                    background-color:  #fff;
                    border-radius: 12px;
                    transform: rotateZ(-90deg) translateX(50%);
                    -webkit-transform: rotateZ(-90deg) translateX(50%);
                }
            
                
            }
            
            &:hover {
                width: 37vw;
            }
        }

        &-menu {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding-left: 20vw;

            &-ul {
                list-style: none;
                &-li {
                    margin-bottom: 1.3rem;
                    font-size: 3vmax;
                    transition: all .25s;

                    & a {
                        color: #fff;
                        text-decoration: none;
                        user-select: none;
                        opacity: 0;
                        
                        &:hover {
                            cursor: pointer;
                        }
                    }

                    &:hover {
                        padding-left: 1rem;
                    }
                }
            }
        }
    }
</style>